<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  //import HomePage from '../../../core/Components/Start.vue'

  export default {
    name: 'FinFitView',
  }

</script>
